module.exports = __webpack_public_path__ + "img/product_43.32415db.webp";